const TedSaveIcon = () => (
  <div>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.59326 3.92188H3.40658C2.26658 3.92188 1.33325 4.8552 1.33325 5.9952V13.5685C1.33325 14.5352 2.02658 14.9485 2.87325 14.4752L5.49325 13.0152C5.77325 12.8619 6.22659 12.8619 6.49992 13.0152L9.11991 14.4752C9.96658 14.9485 10.6599 14.5352 10.6599 13.5685V5.9952C10.6666 4.8552 9.73326 3.92188 8.59326 3.92188Z"
        stroke="#2A60DF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6666 5.9952V13.5685C10.6666 14.5352 9.97325 14.9419 9.12659 14.4752L6.50659 13.0152C6.22659 12.8619 5.77325 12.8619 5.49325 13.0152L2.87325 14.4752C2.02658 14.9419 1.33325 14.5352 1.33325 13.5685V5.9952C1.33325 4.8552 2.26658 3.92188 3.40658 3.92188H8.59326C9.73326 3.92188 10.6666 4.8552 10.6666 5.9952Z"
        stroke="#2A60DF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6666 3.40926V10.9826C14.6666 11.9493 13.9733 12.3559 13.1266 11.8893L10.6666 10.5159V5.99593C10.6666 4.85593 9.73326 3.92261 8.59326 3.92261H5.33325V3.40926C5.33325 2.26926 6.26658 1.33594 7.40658 1.33594H12.5933C13.7333 1.33594 14.6666 2.26926 14.6666 3.40926Z"
        stroke="#2A60DF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedSaveIcon;
